import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { Grid } from '@mui/material';
import WorkIcon from "@mui/icons-material/Work";
import EmojiEmotionsIcon from "@mui/icons-material/EmojiEmotions";
import { UserRoleType } from './SignUpFormWizzard';
import React from 'react';

interface PassedProps {
    onSelect: (role: UserRoleType) => void;
}

const ChooseRoleStep = (props: PassedProps) => {
    return <>
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                // height: "20vh",
                // backgroundColor: "#f7f7f7",
            }}
        >
            <Typography variant="h5">
                I want to
            </Typography>
            <Grid container spacing={1} sx={{ maxWidth: 400, marginTop: '15px' }}>
                <Grid item xs={12} sm={6}>
                    <Box
                        onClick={() => props.onSelect('handyman')}
                        sx={{
                            textAlign: "center",
                            padding: 2,
                            marginRight: '8px',
                            backgroundColor: "white",
                            borderRadius: 2,
                            boxShadow: 2,
                            "&:hover": {
                                boxShadow: 4,
                                cursor: "pointer",
                            },
                        }}
                    >
                        <WorkIcon fontSize="large" sx={{ color: "#1976d2", marginBottom: 1 }} />
                        <Typography variant="subtitle1">Start Earning</Typography>
                    </Box>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <Box
                        onClick={() => props.onSelect('customer')}
                        sx={{
                            textAlign: "center",
                            padding: 2,
                            backgroundColor: "white",
                            borderRadius: 2,
                            boxShadow: 2,
                            "&:hover": {
                                boxShadow: 4,
                                cursor: "pointer",
                            },
                        }}
                    >
                        <EmojiEmotionsIcon fontSize="large" sx={{ color: "#fbc02d", marginBottom: 1 }} />
                        <Typography variant="subtitle1">Order a Service</Typography>
                    </Box>
                </Grid>
            </Grid>
        </Box>
    </>
}

export default ChooseRoleStep;